import { TALENT_STATUS_LABEL } from "@/constants/talentsStatusLabel";
import {
  CurrentHairColorEnum,
  CurrentHairTypeEnum,
  EyeColorEnum,
  HairColorEnum,
  HairTypeEnum,
  PhysicalCharacteristicEnum,
  SkinColorEnum,
} from "@/enums/characteristic";
import { LanguageEnum, LanguageProficiencyEnum } from "@/enums/language";
import { ClothingSizeEnum, ShoeSizeEnum } from "@/enums/measurements";
import { KinshipEnum } from "@/enums/responsible";
import { DanceEnum, DriverLicenseEnum, MusicEnum, SportsEnum } from "@/enums/skill";
import { FollowerRangeEnum, SocialMediaEnum } from "@/enums/social_media";
import { DisabilityTypeEnum, GenderIdentityEnum, NationalityEnum } from "@/enums/talent";
import { enumToOptions } from "@/utils";

export const nationalitiesOptions = enumToOptions(NationalityEnum);

export const genderIdentityOptions = enumToOptions(GenderIdentityEnum);

export const disabilityTypeOptions = enumToOptions(DisabilityTypeEnum);

export const socialMediaOptions = enumToOptions(SocialMediaEnum);

export const followerRangeOptions = enumToOptions(FollowerRangeEnum);

export const eyesColorOptions = enumToOptions(EyeColorEnum);

export const hairColorOptions = enumToOptions(HairColorEnum);

export const currentHairColorOptions = enumToOptions(CurrentHairColorEnum);

export const hairTypeOptions = enumToOptions(HairTypeEnum);

export const currentHairTypeOptions = enumToOptions(CurrentHairTypeEnum);

export const skinColorOptions = enumToOptions(SkinColorEnum);

export const contractStatusOptions = enumToOptions(TALENT_STATUS_LABEL);

export const physicalCharacteristicOptions = enumToOptions(PhysicalCharacteristicEnum);

export const shoeSizeOptions = enumToOptions(ShoeSizeEnum);

export const clothingSizeOptions = enumToOptions(ClothingSizeEnum);

export const languagesOptions = enumToOptions(LanguageEnum);

export const languageProficiencyOptions = enumToOptions(LanguageProficiencyEnum);

export const driverLicenseOptions = enumToOptions(DriverLicenseEnum);

export const sportsOptions = enumToOptions(SportsEnum);

export const musicOptions = enumToOptions(MusicEnum);

export const danceOptions = enumToOptions(DanceEnum);

export const kinshipOptions = enumToOptions(KinshipEnum);

// Novos arrays para casos de uso específicos de filtros
export const booleanOptions = [
  {
    label: "Sim",
    value: true,
  },
  {
    label: "Não",
    value: false,
  },
];

export const closingLocationOptions = [
  {
    label: "Vogue",
    value: "VOGUE",
  },
  {
    label: "Younique",
    value: "YOUNIQUE",
  },
  {
    label: "Baby",
    value: "BABY",
  },
  {
    label: "Eventos",
    value: "EVENTOS",
  },
  {
    label: "Fradique",
    value: "FRADIQUE",
  },
  {
    label: "Rebouças",
    value: "REBOUCAS",
  },
  {
    label: "Seletiva 1",
    value: "SELETIVA_1",
  },
  {
    label: "Seletiva 2",
    value: "SELETIVA_2",
  },
];

export const tattooOptions = [
  {
    label: "Possui tatuagem",
    value: "true",
  },
  {
    label: "Não possui tatuagem",
    value: "false",
  },
];

export const siblingOptions = [
  {
    label: "Possui",
    value: "HAS_SIBLING",
  },
  {
    label: "Não possui",
    value: "NO_SIBLING",
  },
  {
    label: "É gêmeo",
    value: "IS_TWIN",
  },
];

export const talentStatusOptions = [
  {
    label: "Ativo",
    value: "ACTIVE",
  },
  {
    label: "Stand by",
    value: "STAND_BY",
  },
];
